import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './styles/coin-form.css';
import './styles/coin-list.css';
import './styles/coin-catalog.css';
import './styles/admin-dashboard.css';
import './styles/portfolio-dashboard.css';
import './styles/spot-prices.css';
import './styles/coin-case.css';
import './styles/coin-add.css';
import './styles/auth.css';
import './styles/home.css';
import './styles/pagination.css';

import App from './components/App';
import { FirebaseContext } from './components/Firebase';
import { createFirebaseServices } from './firebase/services';

const firebaseServices = createFirebaseServices();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <FirebaseContext.Provider value={firebaseServices}>
    <App />
  </FirebaseContext.Provider>
);
